import { type ReactNode } from "react";

import { Box, Chip, Typography } from "@mui/material";

import { theme } from "@/src/theme/theme";

interface SearchFilterItemProps {
  title: string;
  children: ReactNode;
  selectedValues?: string[] | number[] | undefined;
  handleDelete?: (item) => void;
  showSelectedValues?: boolean;
  "data-testid"?: string;
}

const SearchFilterItem = (props: SearchFilterItemProps) => {
  const {
    title,
    children,
    selectedValues,
    handleDelete,
    showSelectedValues,
    "data-testid": dataTestId
  } = props;
  return (
    <Box sx={{ mt: 1 }} data-testid={dataTestId}>
      <Typography
        variant="h6"
        sx={{
          display: "flex",
          alignItems: "center",
          width: "33%"
        }}
      >
        {title}
      </Typography>
      <Typography
        sx={{
          color: theme.palette.text.secondary,
          alignItems: "end",
          display: "flex",
          flexWrap: "wrap"
        }}
        component="span"
      >
        {selectedValues &&
          showSelectedValues &&
          selectedValues.map((selectedValue, index) => {
            return (
              <Chip
                sx={{ m: 0, mr: 0.5, mb: 1.5 }}
                size="small"
                key={index + "-filter-item"}
                color="primary"
                label={selectedValue}
                onDelete={() => {
                  handleDelete?.(selectedValue);
                }}
              />
            );
          })}
      </Typography>
      {children}
    </Box>
  );
};

export default SearchFilterItem;
